"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./CalendarPicker.css");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var __1 = require("../..");
var CalendarPickerHeader1_1 = require("./customHeaders/CalendarPickerHeader1");
var react_datepicker_1 = __importDefault(require("react-datepicker"));
var moment_1 = __importDefault(require("moment"));
var string_1 = require("../../utils/string");
var CalendarPickerComp = function (_a) {
    var 
    //date
    selectedDate = _a.selectedDate, maxDate = _a.maxDate, minDate = _a.minDate, includeDates = _a.includeDates, excludeDates = _a.excludeDates, 
    //date range
    startDate = _a.startDate, endDate = _a.endDate, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, 
    //options
    _b = _a.inline, 
    //options
    inline = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.showMonthYearDropdown, showMonthYearDropdown = _d === void 0 ? false : _d, customMonthDropdown = _a.customMonthDropdown, _e = _a.startCollapseExpanded, startCollapseExpanded = _e === void 0 ? false : _e, 
    //callbacks
    onChange = _a.onChange, onCollapseHeaderClick = _a.onCollapseHeaderClick, props = __rest(_a, ["selectedDate", "maxDate", "minDate", "includeDates", "excludeDates", "startDate", "endDate", "selectsStart", "selectsEnd", "inline", "disabled", "showMonthYearDropdown", "customMonthDropdown", "startCollapseExpanded", "onChange", "onCollapseHeaderClick"]);
    var desktopDatepicker = react_1.useRef(null);
    var containerId = react_1.useRef(string_1.getRandomString());
    var describeId = react_1.useRef(string_1.getRandomString());
    //collapse
    var _f = __read(react_1.useState(startCollapseExpanded), 2), collapseExpanded = _f[0], setCollapseExpanded = _f[1];
    react_1.useEffect(function () {
        if (collapseExpanded)
            setCollapseExpanded(false);
    }, [disabled]);
    //filter props.excludeDates to be within min/max range
    //map to group by year > month for faster retrieval
    var exDates = react_1.useRef();
    //filtered exDates to include last month, current month, and next month only
    var _g = __read(react_1.useState(), 2), curExDates = _g[0], setCurExDates = _g[1];
    var curMonth = react_1.useRef();
    react_1.useEffect(function () {
        if (excludeDates && (minDate || maxDate)) {
            exDates.current = mapDatesByYearMonth(excludeDates, minDate, maxDate);
            if (curMonth.current) {
                setCurExDates(getDatesForMonth(exDates.current, curMonth.current));
            }
        }
    }, [excludeDates, minDate, maxDate]);
    //map dates to associative array for faster retrieval
    //filter dates outside min amd max dates
    function mapDatesByYearMonth(dates, startDate, endDate) {
        var datesByYearMonth = [];
        for (var i = 0; i < dates.length; ++i) {
            var d = dates[i];
            var time = d.getTime();
            var isPastStart = startDate ? time >= startDate.getTime() : true;
            var isBehindEnd = endDate ? time <= endDate.getTime() : true;
            //filter dates outside min amd max dates
            if (isPastStart && isBehindEnd) {
                var year = d.getFullYear();
                var month = d.getMonth();
                if (!datesByYearMonth[year]) {
                    // prettier-ignore
                    datesByYearMonth[year] = [[], [], [], [], [], [], [], [], [], [], [], []]; //init months for year
                }
                datesByYearMonth[year][month].push(d);
            }
        }
        return datesByYearMonth;
    }
    function getDatesForMonth(dates, monthDate) {
        var year = monthDate.getFullYear();
        var month = monthDate.getMonth();
        var datesForMonth = [];
        if (dates[year]) {
            var prevMonth = [];
            var nextMonth = [];
            if (month === 0) {
                if (dates[year - 1]) {
                    prevMonth = dates[year - 1][11];
                }
            }
            else if (month === 11) {
                if (dates[year + 1]) {
                    nextMonth = dates[year + 1][0];
                }
            }
            else {
                prevMonth = dates[year][month - 1];
                nextMonth = dates[year][month + 1];
            }
            datesForMonth = __spread(prevMonth, dates[year][month], nextMonth);
        }
        return datesForMonth;
    }
    function updateExcludeDates(date) {
        if (date && exDates.current) {
            curMonth.current = date;
            setCurExDates(getDatesForMonth(exDates.current, date));
        }
    }
    function resetExcludeDates() {
        curMonth.current = undefined;
        setCurExDates(undefined);
    }
    var onDatePickerChange = react_1.useCallback(function (date, event) {
        if (collapseExpanded)
            setCollapseExpanded(false);
        if (excludeDates && !curExDates)
            updateExcludeDates(date);
        if (!disabled && onChange)
            onChange(date, event);
    }, [collapseExpanded, curExDates, excludeDates, disabled, onChange]);
    var onMonthChange = react_1.useCallback(function (date) {
        updateExcludeDates(date);
    }, []);
    var onDayMouseEnter = react_1.useCallback(function (date) {
        updateExcludeDates(date);
    }, []);
    var onKeyDown = react_1.useCallback(function () {
        //because onMonthChange does not fire for accessibility scenarios (typing in input, arrow keys)
        //revert back to using props.onExcludeDates on keydown
        //this will exclude performance enhancements to keep excludeDates functionality
        resetExcludeDates();
    }, []);
    //use custom input for adding ADA labels
    var CustomInput = function (props, ref) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(__1.Icon, { className: classnames_1.default('CalendarPicker_inputIcon', {
                    'CalendarPicker_inputIcon-disabled': props.disabled,
                }), type: __1.IconType.calendar }),
            react_1.default.createElement("input", __assign({}, props, { className: "CalendarPicker_input", "aria-labelledby": containerId.current }))));
    };
    return (react_1.default.createElement("div", __assign({ role: 'application', "aria-label": 'Calendar picker', "aria-describedby": describeId.current, tabIndex: 0, id: containerId.current }, props, { className: classnames_1.default('CalendarPicker', props.className, {
            'CalendarPicker-disabled': disabled,
            'CalendarPicker-inline': inline,
            'CalendarPicker-collapse': !inline && __1.isMobile.any(),
        }) }),
        react_1.default.createElement("span", { id: describeId.current, className: 'sr-only' }, "Press tab to enter. Press escape to exit."),
        !inline && __1.isMobile.any() ? (react_1.default.createElement(__1.Collapse, { "aria-labelledby": containerId.current, expanded: collapseExpanded, disabled: disabled, hasIcon: false, header: react_1.default.createElement("div", { className: 'CalendarPicker_collapseHeader' },
                react_1.default.createElement("div", { className: 'CalendarPicker_collapseHeaderLabel' }, selectedDate
                    ? moment_1.default(selectedDate).format('MMMM DD, YYYY')
                    : ''),
                react_1.default.createElement(__1.Icon, { className: classnames_1.default('CalendarPicker_inputIcon', {
                        'CalendarPicker_inputIcon-disabled': disabled,
                    }), type: __1.IconType.calendar })), onHeaderClick: function (expanded, e) {
                setCollapseExpanded(!collapseExpanded);
                if (onCollapseHeaderClick)
                    onCollapseHeaderClick(expanded, e);
            } },
            react_1.default.createElement("div", { className: 'Datepicker-inline' },
                react_1.default.createElement(react_datepicker_1.default
                //static settings
                , { 
                    //static settings
                    dateFormatCalendar: 'MMM yyyy', dateFormat: 'MMMM d, yyyy', autoComplete: 'off', showDisabledMonthNavigation: true, fixedHeight: true, 
                    //date
                    selected: selectedDate, minDate: minDate, maxDate: maxDate, includeDates: includeDates, excludeDates: curExDates || excludeDates, 
                    //date range
                    startDate: startDate, endDate: endDate, selectsStart: selectsStart, selectsEnd: selectsEnd, 
                    //optional
                    inline: true, disabled: disabled, showMonthYearDropdown: showMonthYearDropdown, renderCustomHeader: customMonthDropdown
                        ? function (headerProps) { return (react_1.default.createElement(CalendarPickerHeader1_1.CalendarPickerHeader1, __assign({}, headerProps, { dropdownItems: customMonthDropdown || [] }))); }
                        : undefined, 
                    //callbacks
                    onChange: onDatePickerChange, onMonthChange: excludeDates && onMonthChange, onDayMouseEnter: excludeDates && !curExDates ? onDayMouseEnter : undefined })))) : (react_1.default.createElement(react_datepicker_1.default, { ref: desktopDatepicker, 
            //static settings
            dateFormatCalendar: 'MMM yyyy', dateFormat: 'MMMM d, yyyy', autoComplete: 'off', showDisabledMonthNavigation: true, fixedHeight: true, 
            //date
            selected: selectedDate, minDate: minDate, maxDate: maxDate, includeDates: includeDates, excludeDates: curExDates || excludeDates, 
            //date range
            startDate: startDate, endDate: endDate, selectsStart: selectsStart, selectsEnd: selectsEnd, 
            //optional
            inline: inline, showMonthYearDropdown: showMonthYearDropdown, renderCustomHeader: customMonthDropdown
                ? function (headerProps) { return (react_1.default.createElement(CalendarPickerHeader1_1.CalendarPickerHeader1, __assign({}, headerProps, { dropdownItems: customMonthDropdown || [] }))); }
                : undefined, customInput: react_1.default.createElement(react_1.default.forwardRef(CustomInput)), disabled: disabled, 
            //callbacks
            onChange: onDatePickerChange, onMonthChange: excludeDates && onMonthChange, onDayMouseEnter: excludeDates && !curExDates ? onDayMouseEnter : undefined, onKeyDown: excludeDates && onKeyDown }))));
};
exports.CalendarPicker = react_1.default.memo(CalendarPickerComp);
